export default __webpack_public_path__ + "cbc1e5e7758246a61dcb1f2b5ea2867b.svg";